import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react'

function Loader(tabelloader) {
  return (<Box
    sx={{ position: 'absolute', top: '50%', right: 0, bottom: 0, left: '50%', color: '#FF5A60' }}>
      <CircularProgress color="inherit" />
      </Box>)
}

export default Loader
